import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { rootState } from "../../../../../../redux/store";
import { ICreateScriptCards } from "../../../../../../interface/interfaces";
import { ROUTES } from "../../../../../../constants/constants";
import { useSendWebsocketMessage } from "../../../../WebSocket/hooks/useSendWebsocketMessage";
import { clearScriptUpdateManagerData, fetchScriptUpdateManagerPending } from "../scriptUpdate.slice";

export const useMergedScripts = (socketRef: React.MutableRefObject<WebSocket | null>, isReady: boolean) => {
        const {scriptUpdateWsData, scriptUpdateManagerData, scriptUpdateManagerError, scriptUpdateManagerLoading} = useAppSelector((state: rootState) => state.scriptUpdate);
        const dispatch = useAppDispatch();
        const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
        const { sendWebsocketMessage } = useSendWebsocketMessage(socketRef);
        const {scriptTrigger} = useAppSelector((state: rootState) => state.trigger);

        const onRevealInFileExplorer = ()=>{
            sendWebsocketMessage(JSON.stringify({
                parameter: "reveal in file explorer",
            }));
        }

        const fetchScriptData = ()=>{
            if (userAndTokenData) {
                sendWebsocketMessage(JSON.stringify({
                    parameter: "Script version",
                    token: userAndTokenData?.token || '',
                }));
    
                dispatch(fetchScriptUpdateManagerPending({
                    url:`${ROUTES.GIT_VERSION}`,
                    token: userAndTokenData?.token || '',
                }))
            }
        }

        useEffect(()=>{
            if(isReady){
                fetchScriptData();
            }
        },[scriptTrigger])


        const onReloadScripts = () => {
            fetchScriptData();
        }
        
        const onUpdateScripts = () => {
            dispatch(clearScriptUpdateManagerData());
            if (userAndTokenData) {
                const body = {
                    parameter: "Download all features",
                    token: userAndTokenData?.token || '',
                }
    
                sendWebsocketMessage(JSON.stringify(body));
            }
        }
    

        const mergedScripts = useMemo(() => {
            const merged = [...scriptUpdateManagerData];
        
            scriptUpdateWsData.forEach(wsItem => {
                const existsInManager = scriptUpdateManagerData.some(managerItem => managerItem.script === wsItem.script);
                if (!existsInManager) {
                    merged.push({
                        script: wsItem.script,
                        gitVersion: '', // ili 'No version',
                        status:'OK'
                    });
                }
            });
    
            merged.sort((a, b) => a.script.localeCompare(b.script));
        
            return merged;
        }, [scriptUpdateManagerData, scriptUpdateWsData]);


        const createScriptCards: ICreateScriptCards[] = mergedScripts.map((managerItem, index) => {
            let localVersion = "";
            let localStatus = "";
            const noVersion = "Unknown";
            const gitVersion = managerItem?.gitVersion  || noVersion;
            const matchData = scriptUpdateWsData.find((wsItem) => wsItem.script === managerItem.script);
            if(matchData){
                localVersion = matchData?.localVersion || noVersion;
                localStatus = matchData?.status || 'NO STATUS';
            }else{
                localVersion = 'No file'
                localStatus = 'NO STATUS'
            }
    
            const shouldUpdate = localVersion !== gitVersion && gitVersion !== noVersion && localVersion !== noVersion;
   
            
            const script = managerItem.script;
            const gitStatus = managerItem.status;
            const isOnlyLocal = !scriptUpdateManagerData.some(m => m.script === managerItem.script);

            return {
                shouldUpdate,
                isOnlyLocal,
                index,
                localVersion,
                gitVersion,
                script,
                mergedScripts,
                noVersion,
                gitStatus,
                localStatus
            }
        
        });
        

        return {mergedScripts, scriptUpdateManagerData, scriptUpdateWsData, scriptUpdateManagerError, scriptUpdateManagerLoading, createScriptCards, onReloadScripts, onUpdateScripts, onRevealInFileExplorer}
     
}